import {memo, useImperativeHandle} from 'react'
import styles from './RailsPartial.module.css'
import {clsx} from 'clsx'
import type {QueryRoute} from '@github-ui/react-core/future/query-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

export type SafeRailsHTML = string & {__safeRailsHTMLBrand: never}

export interface RailsPartialHandle {
  refetch: () => void
}

export type RailsPartialProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref'
> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route: QueryRoute<string, string, string, Record<string, any>>
  partialName: string
  ref?: React.Ref<RailsPartialHandle>
}

const RailsPartialUnmemoized = ({ref, route, partialName, className, ...props}: RailsPartialProps) => {
  const fullPartialName = `${route.id}.${partialName}`
  const {data: html, refetch} = useRouteQuery(route, fullPartialName)

  useImperativeHandle(ref, () => ({
    refetch,
  }))

  if (!html) return null

  return (
    <rails-partial
      data-partial-name={fullPartialName}
      class={clsx(styles['d-contents'], className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: html}}
      {...props}
    />
  )
}
RailsPartialUnmemoized.displayName = 'RailsPartial'

const RailsPartial = memo(RailsPartialUnmemoized)

export {RailsPartial}

try{ RailsPartial.displayName ||= 'RailsPartial' } catch {}